import React from 'react';

export default function Notfound() {
  return <h1>not found</h1>;
}
